/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warrantyStorm': {
    width: 24,
    height: 19,
    viewBox: '0 0 24 19',
    data: '<g _fill="#FFF" fill-rule="evenodd"><path pid="0" d="M18.5 4c-.413 0-.834.06-1.278.17A7.485 7.485 0 0010.5 0a7.512 7.512 0 00-7.387 6.23A4.486 4.486 0 000 10.5C0 12.98 2.019 15 4.5 15h2.761c.238 0 .443-.17.49-.4l.778-3.89c.091-.46.395-.85.812-1.06.275-.13.593-.18.897-.13.135.02.273-.01.383-.1a.48.48 0 00.194-.34l.194-1.75c.051-.45.299-.85.682-1.09.378-.24.86-.3 1.283-.16l3 1a1.49 1.49 0 01.96 1.86l-1.665 5.41a.514.514 0 00.075.45c.094.12.244.2.403.2H18.5c3.033 0 5.5-2.47 5.5-5.5S21.533 4 18.5 4"/><path pid="1" d="M15.658 8.03l-3-1a.498.498 0 00-.655.41l-.421 3.79-1.358-.68a.505.505 0 00-.714.35l-1.5 7.5c-.047.24.078.47.299.56a.504.504 0 00.607-.18l2.755-4.14 1.605.81a.502.502 0 00.702-.3l2-6.5a.496.496 0 00-.32-.62"/></g>'
  }
})
